import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';

import {
  getCookie,
  getSessionStorage
} from '../../utils/browserStorageHandler';
import { isServer } from '../common';
import { DynamicObject } from '../commonTypes';
import { COUNTRY, DISPLAY_LANGUAGE_COOKIE } from '../constants/cookieConstants';
import { New_CC_Campaign_AVOD_Message } from '../constants/stringConstants';

export function getSpecialPriceText(priceText: string): string {
  // Dynamically setting plan price for teaser banner from subscription api
  const {
    displayPrice,
    sellPrice,
    currency = '₹',
    billingFrequency = 0,
    title: packTitle = ''
  } = (window as any).specialPlan || {};
  const specialPriceMessage =
    priceText &&
    priceText
      .replace('{{price}}', sellPrice)
      .replace(
        '{{discount_value_computed}}',
        String(
          Math.floor(((displayPrice - sellPrice) * 100) / displayPrice) || 0
        )
      )
      .replace('{{currency}}', currency)
      .replace(
        '{{duration}}',
        String(
          getDaysInYearOrMonthInEnglish({
            days: billingFrequency,
            skipLiteralOne: true
          })
        )
      )
      .replace('INR', '₹')
      .replace('{{pack_title}}', packTitle);
  return specialPriceMessage;
}

export const getDaysInYearOrMonthInEnglish = ({
  days,
  skipLiteralOne = false
}: any) => {
  if (typeof days === 'number') {
    const monthCount = Math.floor(days / 30);
    if (monthCount > 1 && monthCount < 12) {
      return `${monthCount} Months`;
    }
    if (monthCount === 12) {
      return `${skipLiteralOne ? '' : '1 '}Year`;
    }
    if (monthCount === 1) {
      return `${skipLiteralOne ? '' : '1 '}Month`;
    }
    if (monthCount === 0) {
      return `${days} ${days > 1 ? 'Days' : 'Day'}`;
    }
  }
  return null;
};

export const businessType = (
  type: string,
  billingType: string,
  isEduauraa = false
) => {
  if (
    type === 'premium' ||
    type === 'premium_downloadable' ||
    billingType === 'club' ||
    billingType === 'premium' ||
    isEduauraa
  ) {
    return true;
  }
  return false;
};

export const checkIfIPMLEnabled = (data: any) => {
  return (
    data &&
    data.tags &&
    data.tags.find((item: any) => item === 'ipml_enabled') &&
    data.business_type &&
    (data.business_type.includes('advertisement') ||
      data.business_type.includes('advertisement_downloadable') ||
      data.business_type.includes('free'))
  );
};
// to do need expertise to solve this complexity
// eslint-disable-next-line cyclomatic-complexity/zee-codeBlockComplexity
export function triggerTeaserBanner({ playerRef }: any) {
  const {
    singlePlayDetails = {},
    playerConfig = {},
    playableData = {}
  } = playerRef || {};
  const { messages = {} } = (window as any).translationsAndConfigs || {};
  const {
    country = 'IN',
    tvodObj = null,
    userType = 'guest',
    shouldSubscriptionNudgeDisplayed,
    mixpanelData: { isEduauraa = false } = {}
  } = playerConfig || {};
  const {
    assetDetails = {},
    entitlement = {},
    error_code = ''
  } = singlePlayDetails || {};
  const {
    asset_type: assetType,
    asset_subtype: assetSubType,
    billing_type,
    business_type,
    show_details,
    tags = []
  } = assetDetails;
  const isIPMLEnabled =
    country === 'IN' &&
    Object.keys(assetDetails).length &&
    checkIfIPMLEnabled(assetDetails);
  const { isTrailer, isTVOD } = entitlement || { isTrailer: true };
  const isContentPremium = businessType(business_type, billing_type);
  const contentPremiumType = contentBillingType(business_type, billing_type);
  const isAndroid =
    window &&
    window.navigator &&
    window.navigator.userAgent &&
    window.navigator.userAgent.toLowerCase().indexOf('android') > -1;
  let notEduuraContent = !isEduauraa;
  if (
    notEduuraContent &&
    tags.length &&
    tags.find((item: any) => item === 'Eduauraa')
  ) {
    notEduuraContent = false;
  }
  const teaserBannerData = {
    message: '',
    isAppInstall: false
  };
  if (Object.keys(messages).length) {
    const {
      GET_PREMIUM_25_OFF,
      Subscribe_Premium_Watch_Ad_Free,
      Subscribe_Premium_Watch_Next_Episode,
      Subscribe_Premium_Watch_Show,
      WebToApp_AVODMsg_InstallAppSeamless,
      NewNudge_AVODMessage_BelowPlayer_Text
    } = messages;
    const displayLang = String(getCookie(DISPLAY_LANGUAGE_COOKIE));
    const AVODNudge_Message_Text =
      country.toLowerCase() === 'in' && displayLang?.toLowerCase() === 'en'
        ? New_CC_Campaign_AVOD_Message
        : NewNudge_AVODMessage_BelowPlayer_Text;
    // Commenting only for 10% off CC campaign
    // const specialPlanMessage = getSpecialPriceText(GET_PREMIUM_25_OFF);
    const specialPlanMessage = getSpecialPriceText(AVODNudge_Message_Text);
    const avodNudgeMessage = getSpecialPriceText(AVODNudge_Message_Text);

    if (error_code === '3814') {
      teaserBannerData.message = '';
      teaserBannerData.isAppInstall = false;
      // return null;
    }
    if (assetDetails?.content_partner_details?.content_partner_id) {
      teaserBannerData.message = '';
      teaserBannerData.isAppInstall = false;
      // return null;
    }
    // if (isTVOD || tvodObj || business_type.includes('tvod') || isIPMLEnabled) {
    //   // return null;
    // }
    if (country.toLowerCase() !== 'in') {
      if (
        playableData.asset_subtype === 'trailer' ||
        playableData.asset_subtype === 'promo'
      ) {
        if (
          assetDetails &&
          (assetDetails.isEntitlementFailed ||
            (!assetDetails.isEntitlementFailed && userType !== 'premium'))
        ) {
          teaserBannerData.message = '';
          teaserBannerData.isAppInstall = false;
        }
        // return null;
      } else if (
        notEduuraContent &&
        shouldSubscriptionNudgeDisplayed({ playerRef, nudgeType: 'banner' })
      ) {
        teaserBannerData.message = avodNudgeMessage;
        teaserBannerData.isAppInstall = false;
        // return null;
      }
      // return null;
    }
    if (
      !assetDetails.isEntitlementFailed &&
      userType !== 'premium' &&
      (assetSubType === 'trailer' ||
        assetSubType === 'promo' ||
        assetSubType === 'teaser')
    ) {
      let contentData = {} as any;
      if (
        playableData.asset_subtype === 'movie' &&
        playableData.related &&
        playableData.related.length
      ) {
        const filteredData = playableData.related.filter(
          (data: any) => data.asset_subtype === 'movie'
        );
        contentData = filteredData && filteredData.length && filteredData[0];
      } else if (playableData.asset_subtype === 'episode') {
        contentData = singlePlayDetails.showDetails;
      }
      if (
        contentData &&
        typeof contentData === 'object' &&
        Object.keys(contentData).length
      ) {
        const parentContentType = contentBillingType(
          contentData.business_type,
          contentData.billing_type
        );
        if (parentContentType === 'premium') {
          if (country.toLowerCase() === 'in') {
            teaserBannerData.message = specialPlanMessage;
            teaserBannerData.isAppInstall = false;
          } else {
            teaserBannerData.message = Subscribe_Premium_Watch_Ad_Free;
            teaserBannerData.isAppInstall = false;
          }
        } else {
          teaserBannerData.message = '';
          teaserBannerData.isAppInstall = false;
        }
      } else {
        teaserBannerData.message = '';
        teaserBannerData.isAppInstall = false;
      }
    } else if (assetType === 0) {
      if (isTrailer && contentPremiumType === 'premium') {
        if (country.toLowerCase() === 'in') {
          teaserBannerData.message = specialPlanMessage;
          teaserBannerData.isAppInstall = false;
        } else {
          teaserBannerData.message = Subscribe_Premium_Watch_Ad_Free;
          teaserBannerData.isAppInstall = false;
        }
      } else if (
        notEduuraContent &&
        shouldSubscriptionNudgeDisplayed({ playerRef, nudgeType: 'banner' })
      ) {
        teaserBannerData.message = avodNudgeMessage;
        teaserBannerData.isAppInstall = false;
      } else if (!isContentPremium && notEduuraContent && isAndroid) {
        teaserBannerData.message = WebToApp_AVODMsg_InstallAppSeamless;
        teaserBannerData.isAppInstall = true;
      }
    } else if (assetType === 1) {
      const showDetail = singlePlayDetails.showDetails
        ? singlePlayDetails.showDetails
        : show_details;
      const {
        billing_type: showBillingType,
        business_type: showBusinessType,
        extended
      } = showDetail;
      const isShowPremium = businessType(showBusinessType, showBillingType);
      const showPremiumType = contentBillingType(
        showBusinessType,
        showBillingType
      );
      const { broadcast_state: broadcastState } = extended || {};
      const onAirContent = broadcastState === 'ON-AIR';
      if (isTrailer && isContentPremium) {
        if (isShowPremium) {
          if (isTrailer && contentPremiumType === 'premium') {
            if (country.toLowerCase() === 'in') {
              teaserBannerData.message = specialPlanMessage;
              teaserBannerData.isAppInstall = false;
            } else {
              teaserBannerData.message = Subscribe_Premium_Watch_Show;
              teaserBannerData.isAppInstall = false;
            }
          }
        }
      } else if (
        onAirContent &&
        !isContentPremium &&
        !isShowPremium &&
        userType !== 'premium'
      ) {
        teaserBannerData.message = specialPlanMessage;
        teaserBannerData.isAppInstall = false;
      } else if (
        !isContentPremium &&
        isShowPremium &&
        (userType !== 'premium' ||
          localStorage.getItem('entitlementUserType') === 'RSVOD')
      ) {
        if (showPremiumType === 'premium') {
          if (country.toLowerCase() === 'in') {
            teaserBannerData.message = specialPlanMessage;
            teaserBannerData.isAppInstall = false;
          } else {
            teaserBannerData.message = Subscribe_Premium_Watch_Next_Episode;
            teaserBannerData.isAppInstall = false;
          }
        }
      } else if (
        notEduuraContent &&
        shouldSubscriptionNudgeDisplayed({ playerRef, nudgeType: 'banner' })
      ) {
        teaserBannerData.message = avodNudgeMessage;
        teaserBannerData.isAppInstall = false;
      }
    } else if (!isContentPremium && isAndroid && notEduuraContent) {
      teaserBannerData.message = WebToApp_AVODMsg_InstallAppSeamless;
      teaserBannerData.isAppInstall = true;
    }
  }
  return teaserBannerData;
}

export const contentBillingType = (type: any, billingType: any) => {
  let contentType = '';
  if (
    type === ' tvod_downloadable' ||
    type === 'tvod' ||
    type === 'tvod_downloadable'
  ) {
    contentType = 'tvod';
  } else if (businessType(type, billingType)) {
    contentType = billingType === 'club' ? 'club' : 'premium';
  }
  return contentType;
};

// export const fetchEntitlementUserType = (currentActiveSubscriptions) => {
//   let entitlementType = '';
//   let isClubUser = false;
//   // SVOD + club = SVOD
//   // club + RSVOD = RSVOD
//   // SVOD + club + RSVOD = SVOD
//   if (currentActiveSubscriptions.length) {
//     // Pack is Active
//     for (let i = 0; i < currentActiveSubscriptions.length; i += 1) {
//       const subscriptionItemPlan =
//         currentActiveSubscriptions[i].subscription_plan;
//       const isPlanItemSVOD =
//         subscriptionItemPlan &&
//         (subscriptionItemPlan.tv_show_audio_languages.length === 0 ||
//           subscriptionItemPlan.movie_audio_languages.length === 0 ||
//           subscriptionItemPlan.channel_audio_languages.length === 0);
//       const isPlanItemClub =
//         currentActiveSubscriptions[i].subscription_plan.billing_type === 'club';

//       if (isPlanItemClub) {
//         entitlementType = getEntitlementType('club', entitlementType);
//       } else if (isPlanItemSVOD) {
//         entitlementType = 'SVOD';
//         break;
//       } else {
//         entitlementType = getEntitlementType('RSVOD', entitlementType);
//       }

//       if (isPlanItemClub) {
//         isClubUser = true;
//       }
//     }
//   }
//   return {
//     entitlementType,
//     isClubUser
//   };
// };

// export const getIsContentAccessible = (
//   packTypeFromReducer,
//   subscribedLanguages,
//   EpisodeItem,
//   isClubUser
// ) => {
//   const packType = packTypeFromReducer;
//   let isContentAccessible = false;
//   if (packType === 'SVOD') {
//     isContentAccessible = true;
//   } else if (isClubUser && EpisodeItem.billing_type === 'club') {
//     isContentAccessible = true;
//   } else if (packType === 'RSVOD') {
//     let assetType = '';
//     switch (EpisodeItem.asset_type) {
//       case 0:
//         assetType = 'movie_audio_languages';
//         break;
//       case 1:
//         assetType = 'tv_show_audio_languages';
//         break;
//       case 6:
//         assetType = 'tv_show_audio_languages';
//         break;
//       case 10:
//         assetType = 'channel_audio_languages';
//         break;
//       default:
//         break;
//     }
//     if (assetType !== '') {
//       subscribedLanguages.forEach((pack) => {
//         if (
//           EpisodeItem.audio_languages &&
//           EpisodeItem.audio_languages.includes(pack[assetType][0])
//         ) {
//           isContentAccessible = true;
//         }
//       });
//     }
//   }
//   return isContentAccessible;
// };

export const getEntitlementType = (newType: string, existingType: string) => {
  const precedenceArray = ['club', 'RSVOD', 'SVOD'];
  if (
    precedenceArray.indexOf(newType) > precedenceArray.indexOf(existingType)
  ) {
    return newType;
  }
  return existingType;
};

export const getAutomaticAgeRating = (countryList: Countrylist) => {
  const {
    automatic_pin_settings: { enabled = false, age_rating = null } = {
      enabled: false,
      age_rating: null
    }
  } = countryList || {};

  let automaticAgeRatingVal: any = false;
  if (enabled && age_rating) {
    automaticAgeRatingVal = parseInt(age_rating, 10);
  }
  return automaticAgeRatingVal;
};

export const playerCompatabilityErrorCodes = {
  PLAYBACK_SESSION_ERROR: '6014',
  PLATFORM_NOT_SUPPORTED_MWEB: '610',
  PLAYBACK_RESTRICTED_CODE: '4012',
  TVOD_DEVICE_LIMIT_CODE: '3603',
  PLAYBACK_ERROR_RELOAD: '401',
  CONTENT_NOT_AVAILABLE: '607',
  CONCURRENT_STREAM_LIMIT: '3609',
  PLAN_INCOMPATIBLE: '3610'
};

export function getPlanTitleText(msgText: string, userData: DynamicObject) {
  let planMessage;
  if (userData && userData.subscription.length > 0) {
    planMessage = msgText.replace(
      '{{plan_title}}',
      userData.subscription[0].subscription_plan.title
    );
  } else {
    planMessage = msgText.replace('{{plan_title}}', 'N/A');
  }

  return planMessage;
}
export const globalUrlHelper = (url = '', isTruncate = false) => {
  let finalUrl = url;
  if (!isServer) {
    const displayLang = getCookie(DISPLAY_LANGUAGE_COOKIE);
    const country = getCookie(COUNTRY);
    if (finalUrl && country !== 'IN') {
      finalUrl = isTruncate
        ? url && displayLang === 'en'
          ? url.replace(`/global`, '')
          : url.replace(`/global/${displayLang}`, '')
        : displayLang === 'en'
        ? `/global${url}`
        : `/global/${displayLang}${url}`;
      if (finalUrl !== '/' && finalUrl[finalUrl.length - 1] === '/') {
        finalUrl = finalUrl.substring(0, finalUrl.length - 1);
      }
    }
  }

  return finalUrl;
};

export const getContentOwner = (partnerDetails: {
  content_partner_id?: string;
  content_partner_name?: string;
}) => {
  let contentOwner = 'Zee5';
  if (
    partnerDetails &&
    Object.keys(partnerDetails).length &&
    partnerDetails?.content_partner_id
  ) {
    contentOwner = partnerDetails?.content_partner_name || '';
  }
  return contentOwner;
};

export const replaceRegionalTitleCss = (displayLang: string | undefined) => {
  let className = '';
  if (displayLang !== 'en') {
    className += `regionalLang ${displayLang}_regionalLang`;
  }
  return className;
};
